export enum PermissionsRoles {
  DASHBOARD_READ = "portal.billing.dashboard.read",
  DEFAULTERS_READ = "portal.billing.defaulters.read",
  DEFAULTERS_CHARGE = "portal.billing.defaulters.charge",
  COMMISSIONS_READ = "portal.billing.commissions.read",
  ADMIN = "portal.billing.admin",
}
